import { buildUserStoragePath } from './userStoragePaths';

export type AssignmentSubmissionImageType = 'general' | 'project';

export const normalizeMemberGroupKey = (memberGroup?: string): string => {
  const g = (memberGroup || 'A').toString().trim().toUpperCase();
  return g || 'A';
};

export const buildAssignmentSubmissionImagePath = (params: {
  teacherUserId: string;
  classId: string;
  memberGroup?: string;
  assignmentType: AssignmentSubmissionImageType;
  assignmentId: string;
  studentId: string;
  subTaskId?: string;
  extension?: string;
}): string => {
  const groupKey = normalizeMemberGroupKey(params.memberGroup);
  const ext = (params.extension || 'webp').replace(/^\./, '');
  const base = buildUserStoragePath(
    params.teacherUserId,
    params.classId,
    'AssignmentSubmissions',
    groupKey
  );

  if (params.assignmentType === 'general') {
    return `${base}/general/${params.assignmentId}/${params.studentId}.${ext}`;
  }

  if (!params.subTaskId) {
    throw new Error('프로젝트 과제 이미지 경로에는 subTaskId가 필요합니다.');
  }

  return `${base}/project/${params.assignmentId}/${params.subTaskId}/${params.studentId}.${ext}`;
};

/** 과제 삭제 시 listAll용 prefix */
export const buildGeneralAssignmentSubmissionPrefix = (
  teacherUserId: string,
  classId: string,
  memberGroup: string | undefined,
  assignmentId: string
): string => {
  const groupKey = normalizeMemberGroupKey(memberGroup);
  return `${buildUserStoragePath(teacherUserId, classId, 'AssignmentSubmissions', groupKey)}/general/${assignmentId}/`;
};

export const buildProjectAssignmentSubmissionPrefix = (
  teacherUserId: string,
  classId: string,
  memberGroup: string | undefined,
  projectId: string
): string => {
  const groupKey = normalizeMemberGroupKey(memberGroup);
  return `${buildUserStoragePath(teacherUserId, classId, 'AssignmentSubmissions', groupKey)}/project/${projectId}/`;
};

export const buildProjectSubTaskSubmissionPrefix = (
  teacherUserId: string,
  classId: string,
  memberGroup: string | undefined,
  projectId: string,
  subTaskId: string
): string => {
  const groupKey = normalizeMemberGroupKey(memberGroup);
  return `${buildUserStoragePath(teacherUserId, classId, 'AssignmentSubmissions', groupKey)}/project/${projectId}/${subTaskId}/`;
};
